import "./Style/loader.css";

const LoaderIcon = () => {
    return (
        <div className="flex flex-col items-center justify-center h-[26rem]">
            <div className="lds-default">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
            </div>
        </div>
    )
}

export default LoaderIcon;